<script lang="ts">
  import { IntersectionObserver } from "@opera-gx/components/v6";
  import { format, getDate, parseISO } from "date-fns";
  import { tick } from "svelte";
  import { get } from "svelte/store";
  // prettier-ignore
  import { fade } from "svelte/transition";

  import Image from "../components/Image.svelte";
  import Tile from "../components/Tile/Tile.svelte";
  import { language } from "../store/language";
  import { oldTheme } from "../store/theme";
  import { themeConfig } from "../themes/themeConfig";

  let itemWidth = 80;
  let wrapper: HTMLElement;

  export let items;
  export let section_title: string;
  export let id: number;
  export let key = "release-calendar";

  let disableSmoothScroll = false;

  const ITEM_GAP = 16;

  function findCalendarIndex(calendars) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    const index = calendars.findIndex((calendar) => {
      const calendarDate = new Date(calendar.release);
      return calendarDate > yesterday;
    });

    return index;
  }

  const positionScrollContent = async (
    wrapper: HTMLElement,
    itemWidth: number,
    indexOfCurrent: number,
  ) => {
    if (!wrapper) {
      return;
    }

    disableSmoothScroll = true;

    await tick();

    const scrollLeft = (itemWidth + ITEM_GAP) * indexOfCurrent;

    if (wrapper.scrollLeft !== scrollLeft) {
      wrapper.scrollLeft = scrollLeft;
    }

    await tick();

    disableSmoothScroll = false;
  };

  $: if (items && items.length > 0) {
    positionScrollContent(wrapper, itemWidth, findCalendarIndex(items));
  }

  function truncateText(text: string, maxLength: number) {
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }

    return text;
  }
</script>

{#if items}
  <section id={key !== "" ? `gx-section_${key}` : null} class="flex flex-col">
    <h2
      transition:fade
      class="pl-left pr-right mb-4 text-lg font-semibold"
      style="color: hsl(var(--color-gxm-text-on-wallpaper))">
      {section_title}
    </h2>
    <div
      transition:fade
      class="horizontal-scroll gap-19 flex py-4"
      class:scroll-auto={disableSmoothScroll}
      bind:this={wrapper}>
      {#if items && items.length > 0}
        {#each items as calendar}
          <div class="mr-2.5 aspect-[5/6] h-24 snap-start">
            {#if wrapper}
              <IntersectionObserver
                once
                root={wrapper}
                margin="0px 600px"
                let:intersecting>
                {#if intersecting}
                  <Tile
                    let:class={tile}
                    tag={calendar?.tag}
                    tagColor={calendar?.tag?.color}
                    tagText={calendar?.tag?.name}>
                    <a
                      href="/calendar?id={id}&gameId={calendar?.game?.id}&lang={get(
                        language,
                      )}&colors={JSON.stringify(window?.oprt?.gxCornerConfig?.colors) ||
                        ''}&theme={$themeConfig?.theme || $oldTheme}"
                      class="{tile} to-accent/40 text-shadow after:to-accent relative block aspect-[5/6] h-24 bg-gradient-to-br from-transparent bg-cover bg-center bg-no-repeat text-white after:bg-gradient-to-br after:from-transparent after:via-transparent"
                      target="_blank">
                      <Image
                        src={calendar.game?.imageCoverVertical?.url}
                        w={80}
                        h={96}
                        alt={calendar.game?.title} />
                      <div class="text-2xs absolute left-2 top-2 font-semibold">
                        {truncateText(calendar.game?.title, 23)}
                      </div>
                      <div
                        class="absolute bottom-2 left-2 flex h-6 flex-row items-center gap-1 uppercase">
                        <div class="text-base font-semibold">
                          {getDate(parseISO(calendar.release))}
                        </div>
                        <div class="text-base font-extralight">I</div>
                        <div class="text-2xs font-normal leading-none">
                          {format(parseISO(calendar.release), "LLL")}
                        </div>
                      </div>
                    </a>
                  </Tile>
                {/if}
              </IntersectionObserver>
            {/if}
          </div>
        {/each}
      {/if}
    </div>
  </section>
{/if}
